// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"bb8db9b3","20":"62b58457","131":"051230de","150":"4c14588a","487":"8468f4b7","524":"b2992fec","629":"be7bdba5","689":"d2d83332","786":"616d53c6"}[chunkId] + ".chunk.js";
};